import { createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "../../../redux/slice";
import * as api from "../api";

export const doGetAllGroups = createAsyncThunk("groups/doGetAllGroups", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doGetAllGroups(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doCreateGroup = createAsyncThunk("groups/doCreateGroup", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doCreateGroup(params);
    if (!error) thunkAPI.dispatch(setMessage("You action has been completed successfully"));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateGroup = createAsyncThunk("groups/doUpdateGroup", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doUpdateGroup(params);
    if (!error) thunkAPI.dispatch(setMessage("You action has been completed successfully"));
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doDeleteGroup = createAsyncThunk("groups/doDeleteGroup", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doDeleteGroup(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doUpdateGroupInviteEmail = createAsyncThunk(
  "groups/doUpdateGroupInviteEmail",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doUpdateGroupInviteEmail(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doUpdateGroupDisInviteEmail = createAsyncThunk(
  "groups/doUpdateGroupDisInviteEmail",
  async (params, thunkAPI) => {
    try {
      const { response, error } = await api.doUpdateGroupDisInviteEmail(params);
      return error ? thunkAPI.rejectWithValue(error) : response;
    } catch (e) {
      thunkAPI.rejectWithValue(e);
      throw e;
    }
  },
);

export const doGetGroupInviteEmails = createAsyncThunk("groups/doGetGroupInviteEmails", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doGetGroupInviteEmails(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGroupAcceptInvite = createAsyncThunk("groups/doGroupAcceptInvite", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doGroupAcceptInvite(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doOffGroupInviteEmails = createAsyncThunk("groups/doOffGroupInviteEmails", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doOffGroupInviteEmails(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});

export const doGroupGetDetailCode = createAsyncThunk("auth/doGroupGetDetailCode", async (params, thunkAPI) => {
  try {
    const { response, error } = await api.doGroupGetDetailCode(params);
    return error ? thunkAPI.rejectWithValue(error) : response;
  } catch (e) {
    thunkAPI.rejectWithValue(e);
    throw e;
  }
});
